// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = require('./_object-keys-internal');
var hiddenKeys = require('./_enum-bug-keys').concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};



//////////////////
// WEBPACK FOOTER
// ./~/babel-polyfill/~/core-js/modules/_object-gopn.js
// module id = 60
// module chunks = 4